import Image from 'next/image';
import Link from 'next/link';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import time from '/public/home/header/time_s.svg';
import training from '/public/home/header/training_s.svg';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 6,
    },
    blueBttn: {
        width: 172,
        height: 46,
        background: '#293398',
        borderRadius: 8,
        marginRight: 10,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
    },
});

const Contact = ({ ...props }) => {
    const classes = useStyles({ windowsize: props.windowsize });

    const coloredSvg = [
        {
            icon: training,
            text: 'Эмч, мэргэжилэнд зориулсан сургалт',
            style: {
                lineHeight: '14px',
            },
            isLink: true,
            link: 'https://lesson.imsm.mn/',
        },
        {
            icon: time,
            text: 'Эмчийн үзлэгийн цаг захиалах',
            style: {
                lineHeight: '14px',
            },
            isLink: true,
            link: 'https://www.youtube.com/',
        },
    ];

    return (
        <Box
            style={{
                display: 'flex',
                justifyContent: props.windowsize > 700 ? 'unset' : 'end',
                marginRight: props.windowsize > 700 ? 0 : 27,
                alignItems: 'center',
            }}
            {...props}
        >
            <>
                {coloredSvg.map((item, ind) => {
                    return (
                        <a legacyBehavior target="_blank" href={item.link} passHref>
                            <div key={ind} className={classes.blueBttn}>
                                <div style={{ width: 38 }}>
                                    <Image
                                        src={item.icon}
                                        width={30}
                                        height={30}
                                        alt="logo image"
                                        priority
                                        fetchpriority="high"
                                    />
                                </div>
                                <div style={{ width: 115 }}>
                                    <Typography
                                        variant="h6"
                                        style={{
                                            color: 'white',
                                            lineHeight: '14px',
                                        }}
                                    >
                                        {item.text}
                                    </Typography>
                                </div>
                            </div>
                        </a>
                    );
                })}
            </>
        </Box>
    );
};

Contact.propTypes = {
    className: PropTypes.string,
};

export default Contact;
